<template>
  <div class="wrap">
    <div class="contents_wrap type2">
      <section>
        <div class="login_box">
          <div class="left">
            <div class="login_logo">
              <h1>AICC Service</h1>
              <span>{{ $store.getters.contactCenterName }}</span>
            </div>
          </div>
          <div class="right">
            <h2>비밀번호 재설정 코드 입력</h2>
            <div class="form_box">
              <p class="login_txt">이메일로 발송 된 코드를 입력해 주세요.</p>
              <div class="hbox jc">
                <aicc-text-field-with-timer class="otp" ref="otp" v-model="otp" :rules="otpValidateRule" @input="initOtpValidation" placeholder="코드" width="100%" :timer="timer" autocomplete="one-time-code" />
              </div>
              <div class="hbox jc">
                <ur-text-field type="password" v-model="password" placeholder="새 비밀번호" width="100%" autocomplete="new-password" @focus="handleInputFocus" @blur="handleInputBlur" />
                <div class="changepw_popup" :style="{ display: isPopupVisible ? 'block' : 'none' }">
                  <ul class="pw_hint_list">
                    <li :class="{'correct': isValidLength, 'wrong': !isValidLength }">비밀번호는 8-12자만 사용 가능</li>
                    <li :class="{'correct': isMixed, 'wrong': !isMixed }">영문자, 숫자, 특수문자 혼합작성</li>
                    <li :class="{'correct': isNotIdenticalConsecutive, 'wrong': !isNotIdenticalConsecutive }">동일한 숫자/문자 3자 이상 연속 사용 불가</li>
                    <li :class="{'correct': isNotConsecutive, 'wrong': !isNotConsecutive }">연속된 숫자/문자 4자 이상 사용 불가</li>
                  </ul>
                </div>
              </div>
              <div class="hbox jc">
                <aicc-text-field-with-timer type="password" v-model="passwordCheck" :rules="passwordCheckValidateRule" placeholder="새 비밀번호 재입력" @keyup.enter="resetPassword" @focus="handleConfirmInputFocus" width="100%" autocomplete="new-password" />
              </div>
              <ur-button class="btn_login" :disabled="isDisabledBtn" @click="resetPassword" width="100%">확인</ur-button>
            </div>
          </div>
        </div>
      </section>
      <!-- Password Reset Success Modal -->
      <ur-modal ref="successModal" :title="'확인'" small @closed="gotoLoginPage()">
        <template>
          새 비밀번호가 성공적으로 변경되었습니다.
        </template>
        <template slot="action">
          <ur-button shape="solid" primary @click="confirmSuccess()" >확인</ur-button>
        </template>
      </ur-modal>
      <!-- Password Reset Fail Modal -->
      <ur-modal ref="failModal" :title="'확인'" small @closed="gotoFindPasswordPage()">
        <template>
          {{failMessage}}
        </template>
        <template slot="action">
          <ur-button shape="solid" primary @click="confirmFail()" >확인</ur-button>
        </template>
      </ur-modal>
    </div>
  </div>
</template>

<script>
import AuthManager from '~system/auth/AuthManager';
import '~assets/css/aicc/home.css';/* css 파일 내 home_footer class 스타일을 가져오기 위한 import  */
import ReplyCode from '~modules/AI/js/ReplyCode.js';

export default {
  name: 'ResetPassword',
  data() {
    return {
      // otp timer
      startTime: null,
      leftTime: 0,
      showTimer: false,
      timerId: '',

      // password change
      otp: '',
      password: '',
      passwordCheck: '',
      loadingFlag: false,
      otpErrorMessage: '',
      otpValidateRule: [
        (v) => this.isOtpEqual || this.otpErrorMessage,
      ],
      passwordCheckValidateRule: [
        (v) => this.isEqual || '비밀번호가 일치하지 않습니다.',
      ],

      // 비밀번호 복잡도 체크
      isPopupVisible: false, // 팝업 힌트의 표시 여부를 저장할 데이터 속성

      // fail modal
      failMessage: '',
    };
  },
  computed: {
    // 재설정 코드 발송시 vuex에 저장한 loginId 조회
    loginId() {
      return this.$store.getters.getLoginId;
    },

    // otp timer
    timer() {
      if (this.showTimer && this.leftTime >= 0) {
        const minutes = Math.floor(this.leftTime / 60);
        const seconds = this.leftTime % 60;
        return `남은시간 ${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
      }

      return '';
    },

    // 비밀번호 validation
    // 확인 버튼 비활성화 여부
    isDisabledBtn() {
      if (this.isOtpEntered && this.isValidLength && this.isMixed && this.isNotIdenticalConsecutive && this.isNotConsecutive && this.isEqual && !this.loadingFlag) {
        return false;
      }
      return true;
    },
    // OTP 입력
    isOtpEntered() {
      return this.otp.length > 0;
    },
    // OTP 확인
    isOtpEqual() {
      return !this.otpErrorMessage; // OTP 확인 결과에 대한 오류 메시지가 있으면, OTP가 일치하지 않는 것으로 판단하고 오류 메시지 출력
    },
    // 길이 8~12자
    isValidLength() {
      return aiccUtils.passwordValidation.isValidLength(this.password);
    },
    // 영문, 숫자, 특수문자(`~!@#$%^&*|\'";:/?) 혼합
    isMixed() {
      return aiccUtils.passwordValidation.isMixed(this.password);
    },
    // 동일한 문자 3개 이상 금지
    isNotIdenticalConsecutive() {
      return aiccUtils.passwordValidation.isNotIdenticalConsecutive(this.password);
    },
    // 연속된 영문, 숫자 4개 이상 금지
    isNotConsecutive() {
      return aiccUtils.passwordValidation.isNotConsecutive(this.password);
    },
    // 비밀번호 확인
    isEqual() {
      if (this.password.length == 0){
        return true;
      }
      return aiccUtils.passwordValidation.isEqual(this.password, this.passwordCheck);
    },
  },
  created() {
    this.startTimer();
  },
  mounted() {
    this.$store.commit('hideGnbMenu');
    this.$store.commit('showFooter');
  },
  beforeDestroy() {
    this.stopTimer();
    this.$store.commit('setLoginId', '');
  },
  methods: {
    // 타이머 시작
    startTimer() {
      this.startTime = this.$store.getters.getOtpStartTime;; // 타이머 기준이 되는 시작 시간(재설정 코드 전송시 vuex에 저장)
      this.updateTimer();
      this.showTimer = true;
      this.timerId = setInterval(() => {
        if (this.leftTime <= 0) {
          this.stopTimer();
          this.openFailModal('입력 시간이 초과되었습니다. 코드를 다시 받아주세요.');
        } else {
          this.updateTimer();
        }
      }, 1000);
    },

    // 타이머 갱신
    updateTimer() {
      this.leftTime = parseInt(600 - ((new Date() - this.startTime) / 1000)); // 600s부터 카운트 다운
    },

    // 타이머 종료
    stopTimer() {
      this.showTimer = false;
      clearInterval(this.timerId);
      this.timerId = '';
    },

    // OTP를 수정하면 OTP 오류 메시지를 삭제하여 OTP validation 초기화
    initOtpValidation() {
      this.otpErrorMessage = '';
    },

    // 비밀번호 복잡도 체크
    handleInputFocus() {
      this.isPopupVisible = true;
    },

    handleInputBlur() {
      this.isPopupVisible = false;
    },

    handleConfirmInputFocus() {
      if (!this.isValidLength || !this.isMixed || !this.isNotIdenticalConsecutive || !this.isNotConsecutive) {
        this.isPopupVisible = true;
      }  
    },

    // 비밀번호 변경
    resetPassword() {
      // validation check
      if (this.isDisabledBtn) {
        return;
      }
      this.loadingFlag = true; // 확인 버튼 비활성화

      AuthManager.encrypt(this.password).then(encryptedPassword => { // 평문 비밀번호를 암호화
        const passwordAsk = {
          ccUrl: aiccUtils.urlUtil.getCcUrl(),
          loginId: this.loginId,
          otp: this.otp,
          encryptedPassword,
        };

        AuthManager.resetPassword(passwordAsk).then(data => {
          if (data.reply.code === ReplyCode.NO_ERROR) { // 비밀번호 변경 성공
            this.stopTimer();
            this.$refs.successModal.open();
          } else { // 비밀번호 변경 실패
            if (data.reply.code === ReplyCode.OTP_EXPIRED) { // 재설정 코드 만료
              this.openFailModal(data.reply.korMsg);
            } else if (data.reply.code === ReplyCode.OTP_NOT_MATCH) { // 재설정 코드 실패
              this.otpErrorMessage = data.customMsg; // 시도횟수가 포함된 customMsg
              this.$refs.otp.validate();
              this.loadingFlag = false; // 확인 버튼 활성화
            } else if (data.reply.code === ReplyCode.OTP_NOT_MATCH_5) { // 재설정 코드 5회 이상 실패
              this.$refs.otp.clearValidation();
              this.openFailModal(data.reply.korMsg);
            } else {
              this.loadingFlag = false; // 확인 버튼 활성화
              utils.aiccMessageBox('확인', data.reply.korMsg, '확인');
            }
          }
        }).catch(err => {
          this.loadingFlag = false; // 확인 버튼 활성화
          console.warn(err);
        });
      });
    },

    // 비밀번호 변경 실패 팝업
    openFailModal(message) {
      this.failMessage = message;
      this.$refs.failModal.open();
    },

    // 비밀번호 변경 실패 확인
    confirmFail() {
      this.$refs.failModal.close();
    },

    // 비밀번호 변경 성공 확인
    confirmSuccess() {
      this.$refs.successModal.close();
    },

    // 비밀번호 찾기
    gotoFindPasswordPage() {
      utils.goPage('/FindPassword');
    },

    // 로그인 화면
    gotoLoginPage() {
      this.$router.replace('/Login');
    },
  },
};
</script>

<style scoped>
/* ======== container ========= */
.wrap {background-color:#f7f7f7; display: flex; justify-content: center; align-items: center;}

/* ========== input =========== */
.otp {margin-bottom: 5px;}

/* ========== button ========== */
.login_box .btn_login {display: block; width: 100%; height: 48px;line-height: 46px; margin-top:24px; background-color:#516af4; font-size: 18px; color:#fff; text-align: center; border: none;}
.login_box .btn_login:hover {background-color:#516af4;}
.login_box .ur-button--disabled {background-color: #f7f7f7 ;color:#a5a5a5;}

/* ==== 비밀번호 복잡도 체크 ==== */
.pw_hint_list {
  text-align: left;
}
.changepw_popup {
  display: none; /* 초기에는 숨김 상태로 설정 */ 
  position: absolute;
  top: 0;
  left: 396px;
  width: 295px;
  background: #fff;
  border: 1px solid #a6a6a6;
}
.changepw_popup::before,
.changepw_popup::after {
  right: 100%;
  top: 23%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.changepw_popup::before {
  border-color: rgba(166, 166, 166, 0);
  border-right-color: #a6a6a6;
  border-width: 10px;
  margin-top: -10px;
}
.changepw_popup::after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 9px;
  margin-top: -9px;
}
.changepw_popup ul{
  width: 100%;
  max-width: 320px;
  padding: 12px 15px;
}
.changepw_popup ul li{
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
  min-height: 16px;
  line-height: 1.29;
  background: url(../../assets/images/aicc/ic-check-dis-sm.png) no-repeat left top;
  padding-left: 24px;
  margin-bottom: 10px;
  overflow: hidden;
}
.changepw_popup ul li.correct{background: url(../../assets/images/aicc/ic-check-sm.png) no-repeat left top;}
.changepw_popup ul li.wrong{color: #db352e;}
</style>
